<template>
  <div class="sld_login">
    <!-- <div class="sld_login_header">
      <div class="content">
        <router-link tag="a" class="l_logo" :to="`/index`">
          <img class="img" :src="configInfo.main_site_logo" :onerror="defaultImg" alt />
        </router-link>
        <div class="r_register_wrap">
          {{ L['我已知悉？'] }}
          <a class="go_register_btn" @click="goRegister">
            {{ L['去注册'] }}
          </a>
        </div>
      </div>
    </div> -->
    <div class="agreement_container">
      <h2 class="agreement_title">{{ agreeContent.title }}</h2>
      <pre class="agreement_content" style="white-space: pre-wrap;" v-html="agreeContent.content"></pre>
    </div>
  </div>
</template>

<script>
import { useRoute, useRouter } from 'vue-router'
import { ref, getCurrentInstance, reactive, onMounted } from 'vue'
import { useStore } from 'vuex'

export default {
  name: 'Agreement',
  setup() {
    const store = useStore()
    const route = useRoute()
    const { proxy } = getCurrentInstance()
    const L = proxy.$getCurLanguage()
    const configInfo = ref(store.state.configInfo)
    const defaultImg = require('@/assets/common_top_logo.png')
    const agreeContent = reactive({
      content: '',
      title: ''
    })
    const agreementCode = reactive({
      agreementCode:
        route.query.type == 1 ? 'register_agreement' : (route.query.type == 2 ?'privacy_policy' : (route.query.type == 3 ? 'asus_user_privacy':(route.query.type == 4 ? 'service_notice':(route.query.type == 5 ? 'activity_rules':'invoice_notice')))) // register_agreement 用户协议  privacy_policy 隐私协议 asus_user_privacy-华硕会员隐私说明,
    })

    const replaceRemWithPx = (inputString) =>{

      const remToPx = (match, p1) => {
        const numericValue = parseFloat(p1); // 提取数字部分
        return numericValue * 10 + "px"; // 转换为 px 单位
      };

      

      return inputString.replace(/(\d*\.?\d+)rem/g, remToPx);
    }

    const getInitData = () => {
      proxy
        .$get('v3/system/front/agreement/detail', agreementCode)
        .then(res => {
          if (res.state == 200) {
            let content = replaceRemWithPx(res.data.content);
            //content = content.replace('list-style-type: none;','list-style-type: none;;white-space: pre-wrap;')
            agreeContent.content = proxy.$quillEscapeToHtml(content)
            console.log('内容',agreeContent.content)
            agreeContent.title = res.data.title
            console.log('条款',agreeContent.title)
          }
        })
    }

    const goRegister = () => {
      // router.push({
      //     path: '/register'
      // })
      // router.back();
      window.close()
    }
    onMounted(() => {
      getInitData()
    })

    return { L, agreeContent, goRegister, configInfo, defaultImg }
  }
}
</script>
<style lang="scss" scoped>
@import '../../../style/agreement.scss';

.agreement_container {
  width: 800px;
  background-color: #F1F3F5 ;
}
.agreement_title{
  font-family: Microsoft YaHei,Microsoft YaHei ;
  font-weight: 500;
  font-size: 30px;
  color: #000000;
  line-height: 45px;
}
.agreement_content {
  font-family: Microsoft YaHei,Microsoft YaHei;
  font-weight: 400;
  font-size: 14px;
  color: #000000;
  line-height: 24px;
}
</style>
<style lang="scss">
.agreement_content {
  img {
    max-width: 100%;
  }

  a {
    display: inline-block;
    margin: 5px auto;
    color: #0000ff;
    text-decoration: underline;
  }

  table {
    border-collapse: collapse;
    padding: 0;
  }

  td,
  th {
    border: 1px solid #ddd;
    padding: 5px 10px;
  }

  ol,
  ul {
    padding-left: 10px;
  }

  ol li,
  ul li {
    list-style: unset;
  }
}
</style>
